var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthCheese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7957 16.583C59.8603 18.09 57.427 18.9877 54.7841 18.9877C48.476 18.9877 43.3622 13.8739 43.3622 7.56573C43.3622 5.58843 43.8646 3.72847 44.7488 2.10657C41.1262 0.744851 37.2016 0 33.103 0C14.8207 0 0 14.8207 0 33.103C0 51.3853 14.8207 66.2061 33.103 66.2061C51.3853 66.2061 66.2061 51.3853 66.2061 33.103C66.2061 27.0865 64.601 21.4449 61.7957 16.583Z",
    fill: "#FFE26D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9092,
    cy: 19.0018,
    r: 6.42651,
    fill: "#F6D655"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.9785,
    cy: 50.6028,
    r: 10.4674,
    fill: "#F6D655"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1232,
    cy: 20.6618,
    r: 6.67145,
    fill: "#F6D655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthCheese);
export default __webpack_public_path__ + "static/media/authCheese.9912956c18f4d852ccf78ebbe19dd471.svg";
export { ForwardRef as ReactComponent };